<template>
    <div>
        <PageHeaderLayout>
            <div class="main-page-content" style="margin-top: 20px;">
                <el-row>
                    <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
                        <el-form-item label="人资公司名称">
                            <el-input v-model="searchCondition.company_name" placeholder="输入公司名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="个税账号状态" prop="salary_tax_status">
                            <el-select v-model="searchCondition.salary_tax_status" filterable clearable placeholder="请选择">
                                <el-option
                                    v-for="item in typeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="searchButton">查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
                <ApeTable
                v-permission:configure_list
                    ref="apeTable"
                    :data="dataList"
                    :columns="columns"
                    :loading="loadingStaus"
                    :pagingData="pagingData"
                    highlight-current-row
                    @switchPaging="switchPaging"
                >
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    label="公司主营业务">
                    <template slot-scope="scope">
                        <div>
                            {{scope.row.desc}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="个税账号状态">
                    <template slot-scope="scope">
                        <div :style="scope.row.salary_tax_status==2?'color:#F56C6C;':''">
                            {{ scope.row.salary_tax_status==0?'可填写':scope.row.salary_tax_status==1?'已填写':scope.row.salary_tax_status==2?'禁用':''}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    align="center"
                    label="操作"
                >
                        <template slot-scope="scope">
                            <el-button v-permission:configure_declare type="text" :disabled="scope.row.salary_tax_status==1" size="mini" @click="updateChannel(scope.row)">填写申报信息</el-button>
                        </template>
                    </el-table-column>
                </ApeTable>
            </div>
        </PageHeaderLayout>
        
        <el-dialog :visible.sync="dialog_declare" title="填写申报信息">
            <div  class="form">
                <el-form v-model="form_declare" label-width="140px">
                    <el-form-item label="企业名称" required>
                        <el-input required placeholder="请输入企业名称" type="text" v-model="form_declare.company_name"></el-input>
                    </el-form-item>
                    <el-form-item label="企业纳税人识别号" required>
                        <el-input required placeholder="请输入企业纳税人识别号" type="text" v-model="form_declare.taxpayer"></el-input>
                    </el-form-item>
                    <el-form-item label="申报地区" required>
                        <el-select placeholder="请选择申报地区" v-model="form_declare.area_code" @change="event_change" filterable width="200px">
                            <el-option v-for="(item_type,item_index) in provinceList" :label="item_type.label" :value="item_type.value" :key="item_index"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="登录方式">
                        <el-radio-group @change="change_radio" v-model="LoginMode" class="elRadioGroup">
                            <el-radio v-for="(item_type,index_type) in LoginModeList" :key="index_type" :label="item_type.value">{{item_type.label}}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                    
                    <el-form-item label="个税账号" required>
                        <el-input placeholder="请输入个税账号" type="text" v-model="form_declare.tax_account"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="个税申报密码" required>
                        <el-input placeholder="请输入个税申报密码" show-password type="text" v-model="form_declare.tax_upload_password"></el-input>
                    </el-form-item>
                    
                    <el-form-item label="个税密码" required>
                        <el-input placeholder="请输入个税密码" show-password type="text" v-model="form_declare.tax_password"></el-input>
                    </el-form-item>
                   
                    <el-row v-permission:configure_declare class="button-class">
                        <div v-for="(item,index) in buttonGroup" :key="index">
                            <el-button class="elButton" :type="item.colorType" @click="buttonGroupTap(index)">{{item.label}}</el-button>
                        </div>
                    </el-row>
        
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from '@/components/ModalDialog'
import UploadFile from "@/components/UploadFile";
import ApeTable from "@/components/ApeTable";
import tzForm from "@/components/tz-form";
import DatePicker from '@/components/DatePicker.vue'
import { mapGetters } from 'vuex'
export default {
    components: {
        tzForm,
        PageHeaderLayout,
        ApeTable,
        ModalDialog,
        UploadFile,
        DatePicker
    },
    data() {
        return {
            LoginMode:1,
            // LoginModeList:[
            //     {
            //         label:'申报密码登录',
            //         value:1
            //     },
            //     {
            //         label:'实名制登录',
            //         value:2
            //     }
            // ],
            provinceList:[],
            dialog_declare:false,
            form_declare:{},
            buttonGroup: [{
                    label: '取消',
                    colorType: 'default',
                    flag: 'cancel'
                },
                {
                    label: '确定',
                    colorType: 'primary',
                    flag: 'ensure',
                    permission: 'Issue_salary'
                }
            ],
            id:'',
            loadingStaus: false,
            // 分页信息
            pagingData:{
                is_show: true,
                layout: 'total, sizes, prev, pager, next, jumper',
                total: 0
            },
            dataList: [],
            columns: [
                {
                    title: "人资公司名称",
                    value: "company_name",
                    header_align: "center",
                    align: "center",
                },
                {
                    title: "负责人手机号",
                    value: "contact_phone",
                    header_align: "center",
                    align: "center",
                },
                {
                    title: "企业税号",
                    value: "taxpayer",
                    header_align: "center",
                    align: "center",
                },
            ],
            searchCondition:{
                status:'',
                corp_name:'',
            },
            typeList:[
                {id:'0',name:'可填写'},
                {id:'1',name:'已填写'},
                // {id:'2',name:'禁用'}
            ],
        };
    },
    watch: {
    },
    methods: {
        // 按钮组点击
        async buttonGroupTap(e) {
            if(e == 1) {
                let error = {
                    company_id:'公司ID',
                    company_name:'请输入公司名称',
                    taxpayer:'请输入企业税号',
                    area_code:'请选择申报地区',
                    tax_password:'请输入个税密码',
                    tax_account:'请输入个税账号',
                    tax_upload_password:'请输入个税申报密码',
                }
                
                for(let key in error){
                    if(!this.form_declare[key]){
                        this.$message.error(`${error[key]}`)
                        return;
                    }
                }
                
                let result = await this.$api.postManageTaxInfo(this.form_declare)
                
                if(result){
                    this.$message.success("保存成功")
                }
                this.init('search')
                this.showAndHideForm()
            }else{
                this.showAndHideForm()
            }
        },
        async event_change (){
            console.log(this.form_declare)
        },
        
        // async change_radio(e){
        //     if(e==1){
        //         delete this.form_declare.tax_account;
        //         delete this.form_declare.tax_password;
        //     }else{
        //         delete this.form_declare.tax_upload_password;
        //     }
        // },
        
        async updateChannel(e){
            console.log(e)
            let {
                company_name,
                id,
                taxpayer,
                area_code,
                tax_account,
                tax_password,
                tax_upload_password
            } = e
            let obj = {
                company_name,
                company_id:id,
                taxpayer,
                area_code,
                tax_account,
                tax_password,
                tax_upload_password
            }
            this.form_declare = obj
            
            this.showAndHideForm()
        },
        async showAndHideForm(){
            this.dialog_declare = !this.dialog_declare
        },
        // 重置分页
        async resetPage() {
            this.$refs.apeTable.currentPage = 1
        },
        async getAreaCodeList(){
            let result = await this.$api.getAreaCodeList()
            console.log(result)
            this.provinceList = result
        },
        // 切换页码操作
        async switchPaging() {
            this.init();
        },
        // 搜索
        searchButton() {
            this.resetPage()
            this.init('search')
        },
        //获取列表
        async init(type) {
            this.loadingStaus=true
            let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
            let searchCondition = this.handleSearchCondition()
            Object.assign(searchCondition,pagingInfo)
            this.dataList = []
            let { items, total} = await this.$api.getManageTaxList(searchCondition)
            this.$nextTick(() => {
                this.dataList=items
            })
            this.pagingData.total = total
            this.offset = searchCondition.current_page
            this.loadingStaus=false
        },
        // 处理搜索条件
        handleSearchCondition() {
            let condition = {}
            if (this.searchCondition.company_name) {
                condition.company_name = this.searchCondition.company_name
            }
            
            if(this.searchCondition.salary_tax_status){
                condition.salary_tax_status = this.searchCondition.salary_tax_status
            }
            
            return condition
        }
    },
    computed: {
        ...mapGetters(['userPermissions'])
    },
    mounted() {
        this.resetPage()
        this.init();
        this.getAreaCodeList()
    },
};
</script>

<style lang="stylus" scoped>
.button-class{
    display: flex;
    align-items: center;
    justify-content: center;
}
.elButton{
    margin:0 10px;
}
.el-button
  margin-right 4px
  margin-bottom 4px
.operation-btn
  margin: 0 20px
.el-button + .el-button
  margin-left: 0
.item-info {
  display: flex;
  flex-direction: row;
}

.item-info-left {
  width: 130px;
  height: 130px;
}

.item-info-right {
  width: 200px;
  padding: 15px;
  line-height: 40px;
}

.item-info-title {
  color: #aeaeb2;
  font-size: 18px;
}

.item-info-price {
  color: #101010;
  font-size: 28px;
}

.item-info-progress {
  width: 76px;
  height: 11px;
  border: 1px solid black;
}

.border-right {
  border-right: 2px solid #BBBBBB;
}

.application-wrapper {
  width: 280px;
}

.invoice-img {
  width: 100%
}
.new-mail-img
  width: 100%
  display: none
.mail-img
  width: 100%
.mail-title
  color: rgba(16, 16, 16, 100)
  font-size: 16px
.mail-content
  color: rgba(16, 16, 16, 100)
  font-size: 16px
.invoice-wrapper
  margin-left: 55px
.expend
  text-align: center
  margin-top: 20px
  color: #333
/deep/.vue-uploader
  width: 98%
</style>